<template>
  <div class="columnwrapper mr-3">
    <b-dropdown
      class="w-100 btn-overflow"
      variant="outline-secondary"
      size="sm"
      :text="name"
    >
      <b-form-group>
        <b-form-checkbox        
          v-model="allSelected"
          :aria-describedby="name"
          :aria-controls="name"
          class="dropdownclass"
          @change="toggleAll"
        >
          <span class="aligntextmiddle">
            {{ allSelected ? "Avmarkera alla" : "Markera alla" }}
          </span>
        </b-form-checkbox>
        <b-form-checkbox-group
          :id="name"
          v-model="formField.selected"
          :name="name"
          class="dropdownclass"
          :aria-label="'Individuella ' + name"
          stacked
        >
          <b-form-checkbox
            v-for="option in formField.options"
            :key="option.value"
            :value="option.value"
          >
            <span class="aligntextmiddle">{{ option.text }}</span>
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "CheckboxDropdownColumns",
  props: {
    name: String,
    formField: Object
  },
  data() {
    return {
      allSelected: false
    };
  },
  watch: {
    formField: {
      handler(formField) {
        if(formField.options.length === formField.selected.length)
          this.allSelected = true;
        else
          this.allSelected = false;
        if(formField.resetDefaultSelected){
          this.resetSelected();
          formField.resetDefaultSelected = false
        }
        this.$emit("input", formField.selected);
      }, deep: true
    },
  },
  mounted() {
    this.resetSelected();
  },
  methods: {
    toggleAll(checked) {
      this.formField.selected = checked ? this.formField.options.map(a => a.value) : [];
    },
    resetSelected() {
      this.formField.selected = this.formField.options.filter(option => option.selected).map(option => option.value);
    }
  }
};
</script>
<style>
.columnwrapper{
  min-width: 10rem;
}
</style>
<style scoped>
.dropdownclass{
  font-size: 0.65em;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.aligntextmiddle{
  color: #495057;
  vertical-align: sub;
  font-size: 1.05em;
}
>>> .dropdown-toggle {
  color: black;
  border-color: rgb(159 157 156 / var(--tw-border-opacity));
  --tw-border-opacity: 1;
  --tw-bg-opacity: 1;
  box-shadow: none;
  outline: none;
}
>>> .dropdown-toggle:hover,
>>> .dropdown-toggle:active,
>>> .dropdown-toggle:focus-visible,
>>> .show > .dropdown-toggle {
  background-color: rgb(139 201 255 / var(--tw-bg-opacity)) !important;
  border-color: rgb(0 147 255 / var(--tw-border-opacity)) !important;
  color: black !important;
}
>>> .groupresultclass {
  font-size: small;
  color: #dc3545;
}
>>> .dropdownclass div {
  display: table;
}
</style>
